import Android from 'assets/images/androidQrCodeCenter.svg'
import iOS from 'assets/images/appleQrCodeCenter.svg'
import Column from 'components/Column'
import CopyToClipboard from 'components/CopyToClipboard'
import I18n from 'components/I18n'
import CloseCircle from 'components/Icons/CloseCircle'
import ComponentsInput from 'components/Input'
import Modal from 'components/Modal'
import Row from 'components/Row'
import {
  SwitchLabel as BaseSwitchLabel,
  SwitchWrapper as BaseSwitchWrapper
} from 'components/Switch'
import { androidAppStoreUrl, iosAppStoreUrl } from 'constants/appStore'
import { actions } from 'data'
import messages from 'lang'
import { QRCodeSVG } from 'qrcode.react'
import React, { useState } from 'react'
import { useDispatch } from 'react-redux'
import styled from 'styled-components'
import { color, screenWidth } from 'utils/styledHelper'

const Wrapper = styled(Column)`
  padding: 1.5rem;
  background: ${color('dark800')};
  border-radius: 0.5rem;
`

const StyledModal = styled(Modal)`
  @media only screen and (min-width: ${screenWidth('sm')}) {
    transform: unset;
    top: 4rem;
    left: unset;
    right: 1rem;
  }
`

const SwitchWrapper = styled(BaseSwitchWrapper)`
  margin-bottom: 1rem;
`

const SwitchLabel = styled(BaseSwitchLabel)`
  font-size: 0.875rem;
  padding: 4px 8px;
`

const InputWrapper = styled.div`
  position: relative;

  div:last-child {
    position: absolute;
    right: 8px;
    bottom: 11px;
  }
`

const Input = styled(ComponentsInput)`
  input {
    max-width: 15rem;
    text-overflow: ellipsis;
    padding-right: 2rem;
    outline: none;
  }
`

const QrWrapper = styled(Row)`
  border-radius: 0.5rem;
  margin-bottom: 1rem;
  background: ${color('white')};
  padding: 0.875rem;
`

const CloseWrapper = styled(Row)`
  position: absolute;
  top: 0.5rem;
  right: 0.5rem;
  cursor: pointer;
`

const MobileInstallModal = ({ setShowQrModal }) => {
  const [showAndroid, setShowAndroid] = useState(false)
  const dispatch = useDispatch()

  return (
    <StyledModal onClose={() => setShowQrModal(false)} overlay={false}>
      <Wrapper alignItems='center'>
        <CloseWrapper onClick={() => setShowQrModal(false)}>
          <CloseCircle size='16px' />
        </CloseWrapper>
        <SwitchWrapper>
          <SwitchLabel
            activeColor={color('dark900')}
            hoverColor={color('dark800')}
            onClick={() => {
              setShowAndroid(false)
              dispatch(
                actions.analytics.trackEvent({
                  key: 'Mobile App Install Device Updated',
                  properties: {
                    device_app: 'APP-iOS'
                  }
                })
              )
            }}
            regularColor={color('dark700')}
            selectedColor={color('dark900')}
            selectedTextColor={color('white')}
            selected={!showAndroid}
            textColor={color('overlayWhite600')}
          >
            <I18n data={messages.ios} />
          </SwitchLabel>
          <SwitchLabel
            activeColor={color('dark900')}
            hoverColor={color('dark800')}
            onClick={() => {
              setShowAndroid(true)
              dispatch(
                actions.analytics.trackEvent({
                  key: 'Mobile App Install Device Updated',
                  properties: {
                    device_app: 'APP-Android'
                  }
                })
              )
            }}
            regularColor={color('dark700')}
            selectedColor={color('dark900')}
            selectedTextColor={color('white')}
            selected={showAndroid}
            textColor={color('overlayWhite600')}
          >
            <I18n data={messages.android} />
          </SwitchLabel>
        </SwitchWrapper>
        <QrWrapper alignItems='center' justifyContent='center'>
          <QRCodeSVG
            imageSettings={{
              excavate: false,
              height: 48,
              src: showAndroid ? Android : iOS,
              width: 48
            }}
            level='M'
            size={198}
            value={showAndroid ? androidAppStoreUrl : iosAppStoreUrl}
          />
        </QrWrapper>
        <InputWrapper>
          <Input
            readOnly
            value={showAndroid ? androidAppStoreUrl : iosAppStoreUrl}
            variant='qrCodeModal'
          />
          <CopyToClipboard
            light
            value={showAndroid ? androidAppStoreUrl : iosAppStoreUrl}
            onCopied={() => {
              dispatch(
                actions.analytics.trackEvent({
                  key: 'Mobile App Install Link Copied',
                  properties: {
                    device_app: showAndroid ? 'APP-Android' : 'APP-iOS'
                  }
                })
              )
            }}
          />
        </InputWrapper>
      </Wrapper>
    </StyledModal>
  )
}

export default MobileInstallModal
